import Phaser from "phaser";
import Pqp from "../../3x1010/Pqp";
import MainScene from "./MainScene";
import ProgressBar from "./ProgressBar";

export default class FullscreenOnOff extends Phaser.GameObjects.Container {
  constructor(scene) {
    super(scene);
  }

  init(flag) {
    this.play = this.scene.add.image(0, 0, "fullon");
    this.add(this.play);
    this.pause = this.scene.add.image(0, 0, "fulloff");
    this.add(this.pause);
    this.setPlay(flag);

    this.setInteractive({ hitArea: new Phaser.Geom.Rectangle(-32, -32, 64, 64), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
    this.on("pointerdown", this.toggleState.bind(this));

    document.addEventListener("fullscreenchange", this.exitHandler.bind(this));
    document.addEventListener("webkitfullscreenchange", this.exitHandler.bind(this));
    document.addEventListener("mozfullscreenchange", this.exitHandler.bind(this));
    document.addEventListener("MSFullscreenChange", this.exitHandler.bind(this));
  }

  exitHandler() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
      ///fire your event
      this.play.visible = true;
      this.pause.visible = false;
    }
  }

  setPlay(flag) {
    this.isPlaying = flag;
    if (flag) {
      this.play.visible = false;
      this.pause.visible = true;
    } else {
      this.play.visible = true;
      this.pause.visible = false;
    }
  }

  toggleState() {
    if (this.scene.scale.isFullscreen) {
      MainScene.that.showDisabler(true);
      this.setPlay(false);
      this.scene.scale.stopFullscreen();
      setTimeout(this.hideDisabler.bind(this), 100);
    } else {
      MainScene.that.showDisabler(true);
      this.setPlay(true);
      this.scene.scale.startFullscreen();
      setTimeout(this.hideDisabler.bind(this), 100);
    }
  }

  hideDisabler() {
    MainScene.that.showDisabler(false);
  }
}
